<template>
    <div class="layout">
        <div class="header">
            <img class="header-logo" src="@/assets/sys/login/logo.png" alt="">
            <div class="header-user">
                <img src="@/assets/home/default_avatar.png" alt="">
                <span>{{userInfo.name}}</span>
                <span @click="handleExit">退出</span>
            </div>

            <!-- <div class="header-tabs">
                <div v-for="(tabItem, tabKey) in tabList" :key="tabKey" :class="`header-tabItem ${tabIndex === tabKey ? 'header-tabItem-active' : ''}`" @click="hanldeSelectTab(tabItem, tabKey)">{{tabItem.name}}</div>
            </div> -->
        </div>

        <div class="header-mobile">
            <div class="header-mobile-menu" @click="handleShowMenu">
                <img src="@/assets/home/wap_more.png" alt="">
            </div>
            <!-- <img v-if="host == 'fmcl.douzhuan.cn'" class="header-mobile-logo" src="@/assets/home/wap_logo.png" alt=""> -->
            <div class="header-mobile-logout" @click="handleExit">
                <img src="@/assets/home/default_avatar.png" alt="">
            </div>

            <Popup v-model="isShowMenu" position="left" style="height: 100%">
                <div class="header-mobile-menuList">
                    <div class="header-mobile-subMenu" v-for="(subMenuItem, subMenuKey) in tabList" :key="subMenuKey">
                        <div class="header-mobile-subMenu-text">{{subMenuItem.name}}</div>
                        <div :class="`header-mobile-menuItem ${path === menuItem.router ? 'header-mobile-menuItem-active' : ''}`" v-for="(menuItem, menuKey) in subMenuItem.children" :key="menuKey" @click="handleSelectMenu(menuItem)">
                            {{menuItem.name}}
                        </div>
                    </div>
                </div>
            </Popup>

        </div>

        <div class="content">
            <router-view />
        </div>
    </div>
</template>

<script>
import { getTabList } from './config'
import { Message } from 'iview'
import router from '@/router'
import { isEmpty } from '@/utils/common'
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'


export default {
    components: {
        Popup
    },
    data() {
        return {
            tabList: getTabList(),
            tabIndex: 0,
            userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
            isShowMenu: false,
            path: "",
            host: ""
        }
    },
    mounted() {
        this.host = location.host
        for (let i = 0; i < this.tabList.length; i++) {
            const tabItem = this.tabList[i]
            for (let j = 0; j < tabItem.children.length; j++) {
                const menuItem = tabItem.children[j]
                if (menuItem.router === this.$route.path) {
                    this.tabIndex = i
                }
            }
        }
        this.path = this.$route.path
    },
    beforeRouteEnter(to, from, next) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        if (!isEmpty(userInfo) && userInfo.token && userInfo.customerId) {
            next()
        } else {
            Message.error('请先登录')
            router.push('/')
        }
    },
    methods: {
        // 点击tab项时触发
        hanldeSelectTab(tabItem, tabKey) {
            if (Array.isArray(tabItem.children) && tabItem.children.length) {
                this.$router.push(tabItem.children[0].router)
            } else {
                this.$router.push(tabItem.router)
            }
            this.tabIndex = tabKey
        },

        // 处理显示菜单
        handleShowMenu() {
            this.isShowMenu = true
        },

        // 处理选择菜单事件
        handleSelectMenu(menuItem) {
            if (this.$route.path !== menuItem.router) {
                this.path = menuItem.router
                this.$router.push(menuItem.router)
            }
            this.isShowMenu = false
        },

        // 点击退出按钮时触发
        handleExit() {
            localStorage.removeItem('userInfo')
            Message.success('退出登录成功')
            this.$router.push('/')
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .layout {
        position: relative;
        height: 100%;
        width: 100%;
        min-height: 800px;
        padding-top: 70px;
        .header {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 70px;
            background: linear-gradient(90deg, #0061e4, #2379ee);
            .header-logo {
                position: absolute;
                left: 40px;
                top: 17px;
                width: 164px;
                height: 36px;
            }
            .header-user {
                position: absolute;
                right: 41px;
                > img {
                    width: 34px;
                    height: 34px;
                    vertical-align: middle;
                    margin-right: 10px;
                }
                > span:nth-child(2) {
                    font-size: 12px;
                    color: #fff;
                    line-height: 70px;
                }
                > span:nth-child(3) {
                    margin-left: 20px;
                    font-size: 12px;
                    color: #fff;
                    cursor: pointer;
                }
            }
            .header-tabs {
                position: absolute;
                left: 19.63542%;
                top: 0;
                height: 100%;
                .header-tabItem {
                    float: left;
                    width: 112px;
                    height: 100%;
                    font-size: 16px;
                    line-height: 70px;
                    text-align: center;
                    font-weight: 500;
                    color: #fff;
                    background-color: #0061e4;
                    transition: all 0.15s;
                    cursor: pointer;
                    user-select: none;
                }
                .header-tabItem-active {
                    background-color: #008fe8;
                }
            }
        }

        .header-mobile {
            display: none;
        }
        .content {
            height: 100%;
        }
        >>> .el-table {
            th.el-table__cell {
                background-color: #eef1f6;
                border-color: #eef1f6;
            }
            .cell {
                padding: 0 10px;
                font-size: 12px;
                line-height: 27px;
            }
            .el-table__cell {
                padding: 10px 0;
                border-bottom: none;
                border-color: #fff;
            }
            .el-table__row--striped .el-table__cell {
                background-color: #f3f6fb;
                border-color: #f3f6fb;
            }
            .hover-row .el-table__cell {
                background-color: #f5f7fa;
            }
            .el-table__fixed::before {
                background-color: #fff;
            }
            .el-table__body-wrapper {
                z-index: 2;
            }
        }
        >>> .el-table::before {
            background-color: #fff;
        }
    }
}

@media screen and (max-width: 768px) {
    .layout {
        position: relative;
        height: 100%;
        width: 100%;
        background-color: #f7f7f7;
        .header {
            display: none;
        }
        .content {
            height: 100%;
        }
        .header-mobile {
            z-index: 9;
            position: fixed;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 0.15rem;
            top: 0;
            left: 0;
            right: 0;
            height: 0.9rem;
            background-color: #008fe8;
            .header-mobile-menu {
                padding: 0.15rem;
                > img {
                    width: 0.3rem;
                    height: 0.27rem;
                }
            }
            .header-mobile-logo {
                width: 1.4rem;
                height: 0.3rem;
            }
            .header-mobile-logo-xr {
                width: 0.6rem;
                height: 0.56rem;
            }
            .header-mobile-logo-ztb {
                width: 1.52rem;
                height: 0.42rem;
            }
            .header-mobile-logo-hy {
                width: 1.14rem;
                height: 0.42rem;
            }
            .header-mobile-logo-jxkj {
                width: 1.76rem;
                height: 0.28rem;
            }
            .header-mobile-logo-cid {
                width: 1.58rem;
                height: 0.39rem;
            }
            .header-mobile-logo-tlcid {
                width: 1.72rem;
                height: 0.34rem;
            }
            .header-mobile-logo-jdwl {
                width: 1.79rem;
                height: 0.33rem;
            }
            .header-mobile-logo-zm {
                width: 0.66rem;
                height: 0.29rem;
            }
            .header-mobile-logo-dou {
                width: 1.31rem;
                height: 0.34rem;
            }
            .header-mobile-logo-hc, .header-mobile-logo-qxcid {
                width: 2.05rem;
                height: 0.34rem;
            }
            .header-mobile-logo-zysj {
                width: 1.41rem;
                height: 0.4rem;
            }
            .header-mobile-logout {
                padding: 0.15rem;
                > img {
                    width: 0.44rem;
                    height: 0.44rem;
                }
            }
            .header-mobile-menuList {
                width: 5.6rem;
                height: 100%;
                overflow-y: auto;
                background-color: #fff;
                .header-mobile-subMenu {
                    padding: 0.5rem 0 0.5rem 0.6rem;
                    border-bottom: 0.02rem solid #e9f0f6;
                    .header-mobile-subMenu-text {
                        font-size: 0.34rem;
                        line-height: 0.34rem;
                        color: #333;
                    }
                    .header-mobile-menuItem {
                        padding-left: 0.28rem;
                        margin-bottom: 0.8rem;
                        font-size: 0.3rem;
                        line-height: 0.28rem;
                        color: #666666;
                        transition: color 0.15s;
                    }
                    .header-mobile-menuItem-active {
                        color: #0061e4;
                    }
                    .header-mobile-menuItem:nth-child(2) {
                        margin-top: 0.7rem;
                    }
                    .header-mobile-menuItem:last-child {
                        margin-bottom: 0.1rem;
                    }
                }
                .header-mobile-subMenu:last-child {
                    border: none;
                }
            }
        }

        >>> .el-table {
            .el-table__header {
                .el-table__cell {
                    padding: 0;
                    height: 0.7rem;
                    background-color: #edf1f7;
                }
            }
            .el-table__row--striped .el-table__cell {
                background-color: #f2f6fc;
                border-color: #f2f6fc;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue